/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PersonaType = {
    User: 'user',
    Bot: 'bot'
} as const;
export type PersonaType = typeof PersonaType[keyof typeof PersonaType];


export function instanceOfPersonaType(value: any): boolean {
    for (const key in PersonaType) {
        if (Object.prototype.hasOwnProperty.call(PersonaType, key)) {
            if (PersonaType[key as keyof typeof PersonaType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PersonaTypeFromJSON(json: any): PersonaType {
    return PersonaTypeFromJSONTyped(json, false);
}

export function PersonaTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaType {
    return json as PersonaType;
}

export function PersonaTypeToJSON(value?: PersonaType | null): any {
    return value as any;
}

export function PersonaTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PersonaType {
    return value as PersonaType;
}

